import script from "./UserRepository.vue?vue&type=script&lang=ts"
export * from "./UserRepository.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__